import { logger } from '@/lib/logger';

export class ClientIdManager {
  private readonly clientId: string;
  private readonly clientIdKey: string;

  constructor(appId: string) {
    this.clientIdKey = `gladlyChat_${appId}_client_id`;
    this.clientId = this.getPersistedClientId() ?? this.generateAndPersist();
  }

  getClientId(): string {
    return this.clientId;
  }

  private getPersistedClientId(): string | null {
    try {
      return localStorage.getItem(this.clientIdKey);
    } catch (error) {
      logger.error('Failed to read clientId:', error);
      return null;
    }
  }

  private setPersistedClientId(value: string): void {
    try {
      localStorage.setItem(this.clientIdKey, value);
    } catch (error) {
      logger.error('Failed to persist clientId:', error);
    }
  }

  private generateAndPersist(): string {
    const id = generateClientId();
    this.setPersistedClientId(id);
    return id;
  }
}

function generateClientId(): string {
  return crypto.randomUUID().replaceAll('-', '');
}
